import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table table-bordered border-0 mb-0 table-edit tw-mt-8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      colspan: "2"
    }, "FAMILY HOUSING EXPENSES")
  ])
], -1)
const _hoisted_3 = ["onUpdate:modelValue"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-plus",
  "aria-hidden": "true"
}, null, -1)

import { toRefs } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyHousingExpenses',
  props: {
    data: {
        type: Object,
        defaul: null,
    },
    addFunction: Function,
    removeFunction: Function,
},
  setup(__props) {

const props = __props;


const { data, addFunction, removeFunction} = toRefs(props);

const addData = () => {
  addFunction.value()
}

const removeItem = (index, ID) => {
    removeFunction.value(index, ID);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.$route.query.table != 'foreign' || _ctx.$route.query.table)
      ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "data",
                key: index
              }, [
                _createElementVNode("td", null, [
                  _createElementVNode("div", null, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": ($event: any) => ((item.expense) = $event)
                    }, null, 8, _hoisted_3), [
                      [_vModelText, item.expense]
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    class: "btn btn-danger btn-sm ms-2",
                    onClick: ($event: any) => (removeItem(index, item.ID))
                  }, _hoisted_6, 8, _hoisted_4)
                ])
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      class: "btn btn-primary px-5 mt-3",
      onClick: addData
    }, [
      _createTextVNode(" Add "),
      _hoisted_7
    ])
  ]))
}
}

})